module.exports = __webpack_public_path__ + "assets/USDT(ERC20).0cfe1867.svg";